import api from "../api";

export default {
    store(data, options) {
        return api.post(`/central/files`, data, options)
    }
}
